import { TimelineControlsState } from "./_TimelineControls";
import { TimelineEventBucketsState } from "./_TimelineEventBuckets";
import { TimelineLineState } from "./_TimelinePopover";

export class TimelineState {
	public readonly controls = new TimelineControlsState();
	public readonly eventBuckets = new TimelineEventBucketsState();
	public readonly lineState = new TimelineLineState();
}
